import {
  IData_Org_With_Profile,
} from '../types/rbac'

export const flattenOrgProfiles = (
  profiles: IData_Org_With_Profile[],
): IData_Org_With_Profile[] => {
  const result: IData_Org_With_Profile[] = []
  const collectOrg = (org: IData_Org_With_Profile) => {
    const newOrg = Object.assign({}, org)
    result.push(newOrg)
    if(newOrg.orgs) {
      newOrg.orgs.forEach(collectOrg)
    }
    newOrg.orgs = []
  }
  profiles.forEach(collectOrg)
  return result
}